import type { SxProps } from '@mui/system'
import theme from 'assets/theme'
import { type ReactElement } from 'react'
import i18n from 'i18next'

// @mui imports
import Chip from '@mui/material/Chip'

export interface AutomaticStatusChipProps {
  sx?: SxProps
}

const AutomaticStatusChip = ({ sx }: AutomaticStatusChipProps): ReactElement => {
  return <Chip label={i18n.t('screens.cs.trip_details.automatic_status')} size="small" color={'primary'} variant="outlined"
    sx={{ ...sx, backgroundColor: theme.palette.darkblue[5] }} />
}

export default AutomaticStatusChip
